import { Pipe, PipeTransform } from '@angular/core';
import { formatCurrency } from './currency-format';
import { ExchangeRateService } from './exchange-rate.service';
import { TranslateService } from '@ngx-translate/core';
import { Currency } from './currency.interface';

@Pipe({name: 'currency'})
export class CurrencyPipe implements PipeTransform {

    constructor(private translate: TranslateService, private exchangeRateService: ExchangeRateService) {}

    transform(value: any, currency?: Currency | string, nonValuatedText?: string): any {
        if (!currency) {
            currency = this.exchangeRateService.getMainCurrency();
        }
        if (typeof currency === 'string') {
            const currencyCode = currency;
            currency = this.exchangeRateService.getCurrency(currencyCode)
            if (!currency) {
                currency = this.exchangeRateService.getCurrency(currencyCode, true);
            }
        }
        if (value === '-') {
            return value;
        }
        if (value === null || Number.isNaN(value) || typeof value === 'undefined') {
            if (nonValuatedText) {
                return nonValuatedText;
            }
            return this.translate.instant('INTERFACE|niewycenione');
        }
        return formatCurrency(value, this.translate.currentLang ?? 'en', currency);
    }
  }
